/* Volta Bundle — Interactive JS */
(function() {
  'use strict';

  const KEY = 'volta-refresh-deadline-v2';

  /* ---- Countdown ---- */
  function initCountdown(containerEl) {
    var dataDeadline = containerEl.getAttribute('data-deadline');
    var target;
    if (dataDeadline) {
      target = new Date(dataDeadline).getTime();
    } else {
      var stored = null;
      try { stored = localStorage.getItem(KEY); } catch(e) {}
      if (stored && parseInt(stored) > Date.now()) {
        target = parseInt(stored);
      } else {
        target = Date.now() + 5 * 24 * 60 * 60 * 1000;
        try { localStorage.setItem(KEY, String(target)); } catch(e) {}
      }
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = Math.max(0, target - Date.now());
      var days  = Math.floor(diff / 86400000); diff -= days  * 86400000;
      var hours = Math.floor(diff / 3600000);  diff -= hours * 3600000;
      var mins  = Math.floor(diff / 60000);    diff -= mins  * 60000;
      var secs  = Math.floor(diff / 1000);
      containerEl.querySelectorAll('[data-cd-days]').forEach(function(el)  { el.textContent = pad(days);  });
      containerEl.querySelectorAll('[data-cd-hours]').forEach(function(el) { el.textContent = pad(hours); });
      containerEl.querySelectorAll('[data-cd-mins]').forEach(function(el)  { el.textContent = pad(mins);  });
      containerEl.querySelectorAll('[data-cd-secs]').forEach(function(el)  { el.textContent = pad(secs);  });
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ---- FAQ Accordion ---- */
  function initFAQ(containerEl) {
    containerEl.querySelectorAll('.volta-faq-q').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.volta-faq-item');
        var isOpen = item.classList.contains('open');
        containerEl.querySelectorAll('.volta-faq-item').forEach(function(i) {
          i.classList.remove('open');
          var ans = i.querySelector('.volta-faq-a');
          if (ans) ans.hidden = true;
        });
        if (!isOpen) {
          item.classList.add('open');
          var ans = item.querySelector('.volta-faq-a');
          if (ans) ans.hidden = false;
        }
      });
    });
    /* hide all answers initially */
    containerEl.querySelectorAll('.volta-faq-a').forEach(function(el) { el.hidden = true; });
  }

  /* ---- Bundle Selector ---- */
  function initSelector(containerEl) {
    var options = containerEl.querySelectorAll('.volta-option');
    var atcBtn = containerEl.querySelector('.volta-selector-atc');

    options.forEach(function(option) {
      option.addEventListener('click', function() {
        options.forEach(function(o) {
          o.classList.remove('selected');
          o.setAttribute('aria-pressed', 'false');
        });
        option.classList.add('selected');
        option.setAttribute('aria-pressed', 'true');
        if (atcBtn && option.dataset.bundleId) {
          atcBtn.dataset.bundle = option.dataset.bundleId;
        }
      });
    });

    // init: sync button to pre-selected option
    var defaultOpt = containerEl.querySelector('.volta-option.selected');
    if (atcBtn && defaultOpt && defaultOpt.dataset.bundleId) {
      atcBtn.dataset.bundle = defaultOpt.dataset.bundleId;
    }
  }

  /* ---- Bundle Add to Cart ---- */
  function initBundleATC() {
    document.querySelectorAll('.volta-bundle-atc').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var bundleId = btn.dataset.bundle;
        var scriptEl = document.getElementById('volta-bundle-' + bundleId);
        if (!scriptEl) return;

        var data;
        try { data = JSON.parse(scriptEl.textContent); } catch(e) { return; }
        if (!data.items || !data.items.length) return;

        var originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: data.items })
        })
        .then(function(r) {
          if (!r.ok) throw new Error('add failed');
          var open = function() {
            document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
            btn.disabled = false;
            btn.innerHTML = originalHTML;
          };
          if (data.discountCode) {
            fetch('/discount/' + encodeURIComponent(data.discountCode), {
              credentials: 'include',
              redirect: 'follow'
            }).finally(open);
          } else {
            open();
          }
        })
        .catch(function() {
          btn.disabled = false;
          btn.innerHTML = originalHTML;
        });
      });
    });
  }

  /* ---- Auto-init ---- */
  function init() {
    document.querySelectorAll('[data-volta-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-volta-faq]').forEach(initFAQ);
    document.querySelectorAll('[data-volta-selector]').forEach(initSelector);
    initBundleATC();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
